import "../scss/style.scss";
import NavigationController from "@/components/NavigationController";
import MobileNavigationController from "@/components/MobileNavigationController";
import ScrollToController from "@/components/ScrollToController";
import Accordion from "@/components/Accordion";
import LightboxController from "@/components/LightboxController";
import VideoPlayer from "@/components/VideoPlayer";
import ParallaxController from "@/components/ParallaxController";
import ModalController from "@/components/ModalController";
import SocialShareController from "@/components/SocialShareController";
import InPageNavigationController from "@/components/InPageNavigationController";
import LoadAnimations from "@/components/LoadAnimations";
import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import ScrollLocker from "@/components/ScrollLocker";
import LazyLoadController from "@/components/LazyLoadController";
import ResponsiveBackground from "@/components/ResponsiveBackground";
import SelectController from "@/components/SelectController";
import DatePicker from "@/components/DatePicker";
import FormCustom from "@/components/FormCustom";
import NewsFilter from "@/filters/NewsFilter";
import AnnouncementsFilter from "@/filters/AnnouncementsFilter";
import StatementsFilter from "@/filters/StatementsFilter";
import DarkModeToggleController from "./components/DarkModeToggleController";
import Search from "./components/Search";

function ready(callbackFunc) {
    if (document.readyState !== "loading") {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener("DOMContentLoaded", callbackFunc);
    } else {
        // Old IE browsers
        document.attachEvent("onreadystatechange", function() {
            if (document.readyState === "complete") {
                callbackFunc();
            }
        });
    }

    window.addEventListener("popstate", (ev) => {
        let currentState = history.state;

        if (currentState) {
            if (typeof currentState.popup && currentState.popup === true) {
                const modalController = new ModalController();
                modalController.loadPostAjax(currentState.postId, false);
            }
        }
    });
}

const options = {
    cache: true,
    plugins: [new SwupBodyClassPlugin(), new SwupPreloadPlugin()],
};

const swup = new Swup(options);

const init = () => {
    const navigationController = new NavigationController();
    const mobileNavigationController = new MobileNavigationController();
    const scrollToController = new ScrollToController();
    const accordion = new Accordion();
    const lightboxController = new LightboxController();
    const videoController = new VideoPlayer();
    const parallaxController = new ParallaxController();
    new DarkModeToggleController();
    const modalController = new ModalController();
    modalController.init();
    const socialShare = new SocialShareController();
    const inPageNavigationController = new InPageNavigationController();
    const loadAnimations = new LoadAnimations();
    const scrollLock = new ScrollLocker();
    const lazyLoad = new LazyLoadController();
    const responsiveBackground = new ResponsiveBackground();
    const selectController = new SelectController();
    const datePicker = new DatePicker();
    const formCustom = new FormCustom();
    scrollLock.unlockScroll();

    const newsFilter = new NewsFilter();
    newsFilter.init();

    const announcementsFilter = new AnnouncementsFilter();
    announcementsFilter.init();

    const statementsFilter = new StatementsFilter();
    statementsFilter.init();

    const links = document.querySelectorAll(".c-document-download-block__link");
    links.forEach((link) => {
        link.addEventListener("click", (e) => {
            return true;
        });
    });

    const search = new Search();
    search.init();
};

// Document ready callback
ready(function() {
    init();
});

swup.on("contentReplaced", () => {
    init();
});

swup.on("clickLink", () => {
    sessionStorage.setItem("last_url", window.location.href);
});
